const state = {
    batches: [],
    redemptions: [],
    loading: {
        batches: false,
        redemptions: false,
        redeem: false
    }
}

export const getters = {
    batches: state => state.batches,
    redemptions: state => state.redemptions,
    loading: state => state.loading,
    availableBatches: state => state.batches.filter(batch =>
        batch.is_valid &&
        batch.generation_policy === 3
    )
}

export const mutations = {
    setBatches(state, batches) {
        state.batches = batches
    },

    setRedemptions(state, redemptions) {
        state.redemptions = redemptions
    },

    addRedemption(state, redemption) {
        state.redemptions.unshift(redemption)
    },

    setLoading(state, { type, value }) {
        state.loading[type] = value
    },

    reset(state) {
        state.batches = []
        state.redemptions = []
    }
}

export const actions = service => ({
    async fetchBatches({ commit }, picaServiceId) {
        commit('setLoading', { type: 'batches', value: true })
        try {
            const batches = await service.fetchBatches(picaServiceId)
            commit('setBatches', batches)
            return batches
        } finally {
            commit('setLoading', { type: 'batches', value: false })
        }
    },

    async fetchRedemptions({ commit }, { userId, picacode }) {
        commit('setLoading', { type: 'redemptions', value: true })
        try {
            const redemptions = await service.fetchRedemptions(userId, picacode)
            commit('setRedemptions', redemptions)
            return redemptions
        } finally {
            commit('setLoading', { type: 'redemptions', value: false })
        }
    },

    async redeemCoupon({ commit }, { batchId, userId, picacode, amount }) {
        commit('setLoading', { type: 'redeem', value: true })
        try {
            const effectParamsOverrides = amount !== undefined ? { amount } : null
            const redemption = await service.redeemCoupon(batchId, userId, picacode, effectParamsOverrides)
            commit('addRedemption', redemption)
            return redemption
        } finally {
            commit('setLoading', { type: 'redeem', value: false })
        }
    },

    reset({ commit }) {
        commit('reset')
    }
})

export default edgeCouponService => ({
    namespaced: true,
    state,
    getters,
    mutations,
    actions: actions(edgeCouponService)
})
